import clsx from "clsx";
import { useState } from "react";
import { FieldError } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react";

interface FloatingInputProps {
	label: string;
	type?: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	error?: FieldError;
	onClick?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FloatingInput = ({
	label,
	type = "text",
	value,
	onChange,
	error,
	onClick,
	...props
}: FloatingInputProps & React.InputHTMLAttributes<HTMLInputElement>) => {
	const [isFocused, setIsFocused] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const shouldFloat = isFocused || value?.length > 0;

	return (
		<div className="relative w-full">
			<input
				type={showPassword ? "text" : type}
				value={value}
				onChange={onChange}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				onClick={onClick}
				className="w-full px-4 pt-6 pb-1  text-base font-medium placeholder-transparent border peer border-border rounded-2xl text-textDark focus:outline-none focus:border-2 focus:border-primary-600"
				placeholder={label}
				id={label}
				{...props}
			/>
			<label
				className={clsx(
					"absolute left-4 text-sm font-medium text-textDark transition-all duration-200 opacity-80",
					shouldFloat ? "top-2 text-xs" : "top-4 text-base",
				)}
				htmlFor={label}
				onClick={() => setIsFocused(true)}
			>
				{label}
			</label>
			{type === "password" &&
				value &&
				value.length > 0 &&
				(showPassword ? (
					<Eye
						className="absolute -translate-y-1/2 right-4 top-7 w-5 h-5 text-textDark"
						onClick={() => setShowPassword(false)}
					/>
				) : (
					<EyeOff
						className="absolute -translate-y-1/2 right-4 top-7 w-5 h-5 text-textDark"
						onClick={() => setShowPassword(true)}
					/>
				))}
			{error && <p className="text-sm text-red-500">{error.message}</p>}
		</div>
	);
};

export default FloatingInput;
